<template>
  <returns-layout-container
    :is-loading="isLoading"
    :with-details="withDetails"
    @rma-changed="handleRmaChanged"
  >
    <slot slot="tabs" name="tabs" />

    <router-link
      slot="close"
      class="returns-container__close-link"
      :to="{
        name: 'returns',
        params: {
          shopId: $route.params.shopId,
        },
        query: $route.query,
      }"
    >
      <ui-icon
        type="x"
        class="order__close-icon"
      />
    </router-link>

    <returns-nav-bar
      slot="navBar"
      :status="filter.status"
      :total="total"
      :offset="offset"
      :limit="limit"
      @refresh="refresh"
      @pagination-change="onPaginationChange"
      @filter-status-change="onFilterStatusChange"
      @search-uuid="onSearchUuid"
    />

    <template v-if="returns.length > 0">
      <returns-list :items="returns">
        <template slot="item" slot-scope="{ item, itemKey, classNames }">
          <router-link :to="{ name: 'rma', params: { shopId, returnId: item.id } }">
            <template slot-scope="{ isActive }">
              <returns-list-item
                :key="itemKey"
                :item="{ ...item }"
                :class-names="classNames"
                :id-active="isActive"
                @navigate="onClickItem"
              />
            </template>
          </router-link>
        </template>
      </returns-list>
    </template>
    <template v-else>
      <no-rmas-found-message />
    </template>
  </returns-layout-container>
</template>

<script>
import { UiIcon } from '@/ui';
import returnsListBehaviorMixin from './returnsListBehavior.mixin';
import ReturnsLayoutContainer from '../components/Layout/Container.vue';
import ReturnsNavBar from '../components/Layout/NavBar.vue';
import ReturnsList from '../components/ReturnsList.vue';
import ReturnsListItem from '../components/RetunsListItem.vue';
import NoRmasFoundMessage from '../components/Messages/NoRmasFound.vue';

export default {
  name: 'ReturnsRmasView',
  components: {
    ReturnsLayoutContainer,
    ReturnsNavBar,
    ReturnsList,
    ReturnsListItem,
    NoRmasFoundMessage,
    UiIcon,
  },

  mixins: [
    returnsListBehaviorMixin,
  ],

  props: {
    shopId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      filter: {
        status: 'pending',
      },
    };
  },

  computed: {
    withDetails() {
      return this.$route.matched.some((route) => route.name === 'rma');
    },

    isLoading() {
      return this.$store.state.rmas.isLoading;
    },

    total() {
      return this.$store.state.rmas.pagination.total;
    },

    offset() {
      return this.$store.state.rmas.pagination.offset;
    },

    limit() {
      return this.$store.state.rmas.pagination.limit;
    },

    returns() {
      return this.$store.getters['rmas/returns'];
    },
  },

  methods: {
    fetch(params) {
      this.$store.dispatch('rmas/fetchForShopV2', {
        contextId: this.shopId,
        params: {
          query: this.search,
          status: this.filter.status,
          limit: this.limit,
          offset: 0,
          ...params,
        },
      });
    },

    handleRmaChanged() {
      this.fetch(this.fetch(this.$route.query));
    },

    onClickItem(returnId) {
      this.$router.push({ path: `${this.$route.path}/${returnId}`, query: this.$route.query });
    },
  },
};
</script>
